import { render, staticRenderFns } from "./time-range-format-editor.vue?vue&type=template&id=6e28b425&scoped=true"
import script from "./time-range-format-editor.vue?vue&type=script&lang=js"
export * from "./time-range-format-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28b425",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e28b425')) {
      api.createRecord('6e28b425', component.options)
    } else {
      api.reload('6e28b425', component.options)
    }
    module.hot.accept("./time-range-format-editor.vue?vue&type=template&id=6e28b425&scoped=true", function () {
      api.rerender('6e28b425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-time-range/time-range-format-editor.vue"
export default component.exports